export const getAddressPredictions = (state) => {
    return state.googleAddressVerify.addressPredictions;
};

export const getAddressInput = (state) => {
    return state.googleAddressVerify.addressInput;
};

export const getSelectedAddress = (state) => {
    return state.googleAddressVerify.selectedAddress;
};

export const getForceAddressValidation = (state) => {
    return state.googleAddressVerify.forceAddressValidation;
};

export const getFetchingAddressDetails = (state) => {
    return state.googleAddressVerify.fetchingAddressDetails;
};

export const getFetchingAddressPredictions = (state) => {
    return state.googleAddressVerify.fetchingAddressPredictions;
};

export const getPendingAddressPredictionsFetch = (state) => {
    return state.googleAddressVerify.pendingAddressPredictionsFetch;
};

export const getShouldDisplayComponent = (state) => {
    return state.googleAddressVerify.shouldDisplayComponent;
};

export const getHasSeenError = (state) => {
    return state.googleAddressVerify.hasSeenError;
};

export const getApiFailureState = (state) => {
    return state.googleAddressVerify.apiFailureState;
};
